package com.essntl.core.settings.ui

import com.essntl.core.settings.domain.repository.ConfigurationRepository
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.State
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getData
import com.essntl.features.currency.domain.repository.CurrencyRepository
import core.config.CurrencyConfig
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class AllowedCurrenciesViewModel(
    private val configurationRepository: ConfigurationRepository,
    private val currencyRepository: CurrencyRepository,
    val state: MutableStateFlow<AllowedCurrenciesState> = MutableStateFlow(AllowedCurrenciesState()),
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {

    fun onEvent(event: AllowedCurrenciesEvent) {
        when (event) {
            is AllowedCurrenciesEvent.GetAllowedCurrencies -> getAllowedCurrencies()
            is AllowedCurrenciesEvent.UpdateAllowedCurrencies -> updateAllowedCurrencies(event)
            is AllowedCurrenciesEvent.DeleteCurrency -> deleteCurrency(event)
            is AllowedCurrenciesEvent.DefaultCurrency -> defaultCurrency(event)
        }
    }

    private fun getAllowedCurrencies() =
        getData(
            getData = { configurationRepository.getAllowedCurrencies() },
            getState = { state.value.getAllowedCurrencies },
            setState = { newState -> state.update { it.copy(getAllowedCurrencies = newState) } },
        )

    private fun updateAllowedCurrencies(event: AllowedCurrenciesEvent.UpdateAllowedCurrencies) =
        state.update {
            it.copy(
                getAllowedCurrencies = State.success(
                    data = event.c,
                ),
            )
        }

    private fun deleteCurrency(event: AllowedCurrenciesEvent.DeleteCurrency) {
        val configurationCurrency = state.value.getAllowedCurrencies.data ?: return

        state.value = state.value.copy(
            deleteLoading = state.value.deleteLoading + event.c,
        )

        scope.launch {
            configurationRepository.updateAllowedCurrencies(
                configurationCurrency.copy(
                    allowed = configurationCurrency.allowed.filter { it != event.c },
                ),
            ).onSuccess {
                state.update {
                    it.copy(
                        getAllowedCurrencies = it.getAllowedCurrencies.copy(
                            data = configurationCurrency.copy(
                                allowed = configurationCurrency.allowed
                                    .filter { c ->
                                        c != event.c
                                    },
                            ),
                        ),
                        deleteLoading = it.deleteLoading - event.c,
                    )
                }
            }.onFailure {
                state.value = state.value.copy(
                    deleteLoading = state.value.deleteLoading - event.c,
                )
            }
        }
    }

    private fun defaultCurrency(event: AllowedCurrenciesEvent.DefaultCurrency) {
        val configurationCurrency = state.value.getAllowedCurrencies.data ?: return

        state.value = state.value.copy(
            updateLoading = state.value.updateLoading + event.c,
        )

        scope.launch {
            configurationRepository.updateAllowedCurrencies(
                configurationCurrency.copy(
                    default = event.c,
                ),
            ).onSuccess { cc ->
                state.update {
                    it.copy(
                        getAllowedCurrencies = State.success(cc),
                        updateLoading = it.updateLoading - event.c,
                    )
                }

                currencyRepository
                    .getByCode(cc.default)
                    .onSuccess { c ->
                        CurrencyConfig.updateCode(code = c.code, symbol = c.symbol)
                    }
            }.onFailure {
                state.value = state.value.copy(
                    updateLoading = state.value.updateLoading - event.c,
                )
            }
        }
    }
}